<template>
    <BjDrawerForm ref="BjDrawerForm" :form="form" label-position="top" :rules="rules" label-width="600px" width="600px" @handleConfirm="handleConfirm">
      <el-col :span="24">
        <el-form-item :label="$t('billingPage.WoodenStandardQty')" prop="standardPallet">
            <BjInputNumber v-model="form.standardPallet" class="full-width" :controls="false" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('billingPage.ChepPalletQty')" prop="chepPallet">
            <BjInputNumber v-model="form.chepPallet" class="full-width" :controls="false" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('billingPage.LoscamPalletQty')" prop="loscomPallet">
            <BjInputNumber v-model="form.loscomPallet" class="full-width" :controls="false" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('billingPage.CSGPalletQty')" prop="csgPallet">
            <BjInputNumber v-model="form.csgPallet" class="full-width" :controls="false" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('WarehouseManagement.form.Description')" prop="remark">
          <BjTextarea v-model="form.remark" clearable :placeholder="$t('WarehouseManagement.form.Description')"></BjTextarea>
        </el-form-item>
      </el-col>
    </BjDrawerForm>
</template>
<script>
import { userApi } from '@/api';

const getDefaultForm = () => {
  return {
    standardPallet: null,
    chepPallet: null,
    loscomPallet: null,
    csgPallet: null,
    remark: null,
  };
};
export default {
  name: '',
  data() {
    // const validateStandard = (rule, value, callback) =>{
    //   if (!value) {
    //     callback(new Error(this.$t('inputText')));
    //   }
    //   if(Number(value) + this.copyForm.standardPallet < 0){
    //     callback(new Error(this.$t('billingPage.errTip')));
    //   }
    //   callback();
    // }
    // const validateChep = (rule, value, callback) =>{
    //   if (!value) {
    //     callback(new Error(this.$t('inputText')));
    //   }
    //   if(Number(value) + this.copyForm.chepPallet < 0){
    //     callback(new Error(this.$t('billingPage.errTip')));
    //   }
    //   callback();
    // }
    // const validateLoscom = (rule, value, callback) =>{
    //   if (!value) {
    //     callback(new Error(this.$t('inputText')));
    //   }
    //   if(Number(value) + this.copyForm.loscomPallet < 0){
    //     callback(new Error(this.$t('billingPage.errTip')));
    //   }
    //   callback();
    // }
    // const validateCsg = (rule, value, callback) =>{
    //   if (!value) {
    //     callback(new Error(this.$t('inputText')));
    //   }
    //   if(Number(value) + this.copyForm.csgPallet < 0){
    //     callback(new Error(this.$t('billingPage.errTip')));
    //   }
    //   callback();
    // }
    return {
      form: getDefaultForm(),
      rules: {
        standardPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        chepPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        loscomPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        csgPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      copyForm:{},
      style:'',
    };
  },
  methods: {
    handleInput(value, name) {
      const intRegex = /^[-+]?\d+$/;
      if (!intRegex.test(value) && value!='-') {
        this.form[name] = Math.trunc(value);
      }
    },
    show(info,value) {
      this.style = value;
      this.copyForm = JSON.parse(JSON.stringify(info));
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(value=='onIN'?this.$t('billingPage.PalletchangeIN'):this.$t('billingPage.PalletchangeOUT'));
    },
    handleConfirm() {
      let POST_DATA = {};
      if(this.style=='onIN'){
        POST_DATA = {
          ...this.copyForm,
          standardPallet: String(this.form.standardPallet),
          chepPallet: String(this.form.chepPallet),
          loscomPallet: String(this.form.loscomPallet),
          csgPallet: String(this.form.csgPallet),
          remark: this.form.remark,
        }
      }else if(this.style == 'onOUT'){
        POST_DATA = {
          ...this.copyForm,
          standardPallet: String(0-this.form.standardPallet),
          chepPallet: String(0-this.form.chepPallet),
          loscomPallet: String(0-this.form.loscomPallet),
          csgPallet: String(0-this.form.csgPallet),
          remark: this.form.remark,
        }
      };
      userApi.validUpdateCustomerPallet(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.form = getDefaultForm()
            this.$emit('reFresh');
            this.$message.success(this.$t('toast.operationSuccessText'));
          }, 500);
        }
      });
    },
  },

}
</script>
<style lang="scss" scoped>
.downtext{
  position: absolute;
  left: 100px;
  top: -27px;
  color: #082dc3;
  text-decoration: underline;
  cursor: pointer;
}
</style>